import gql from "graphql-tag";

const KONTAKT_QUERY = gql`
  query Kontakt {
    contact {
      data {
        attributes {
          telephone
          mobile
          email
          address
          Facebook
          Instagram
          TikTok
          Map {
            data {
              attributes {
                url
              }
            }
          }
          helptime
        }
      }
    }
    categories {
      data {
        attributes {
          slug
          title
        }
      }
    }
    # aboutUs {
    #   data {
    #     attributes {
    #       helptime
    #     }
    #   }
    # }
  }
`;

export default KONTAKT_QUERY;
